import { Pipe, PipeTransform } from '@angular/core';
import { Bucket, File } from '@appbolaget/aware-model';
import { humanFileSize } from '@appbolaget/helpers';

@Pipe({
    name: 'fileDetails',
    standalone: true,
    pure: true,
})
export class FileDetailsPipe implements PipeTransform {
    transform(file: File | Bucket): { label: string; value: string }[] {
        let details = [
            {
                label: 'MEDIA.DETAILS.CREATED_AT',
                value: file.created_at,
            },
            {
                label: 'MEDIA.DETAILS.CHANGED_AT',
                value: file.updated_at,
            },
        ];

        if (file instanceof File) {
            details = [
                ...details,
                {
                    label: 'MEDIA.DETAILS.TYPE',
                    value: file.mime,
                },
                {
                    label: 'MEDIA.DETAILS.SIZE',
                    value: humanFileSize(file.attrOrMeta('size')),
                },
            ];
        }

        if (file.isImage()) {
            const imageDetails = [
                {
                    label: 'Alt-text',
                    value: (file as File).alt,
                },
                {
                    label: 'MEDIA.DETAILS.HEIGHT',
                    value: file.attrOrMeta('height') + ' px',
                },
                {
                    label: 'MEDIA.DETAILS.WIDTH',
                    value: file.attrOrMeta('width') + ' px',
                },
            ];

            details = [...details, ...imageDetails];
        }

        return details.reverse();
    }
}
